/** Guards */
import pixPersonasDetailGuard from '@/guards/pixPersonasDetail.guard.js';

/** Routes */
import mandatesRoutes from './routes/mandates.routes.js';
import propertiesRoutes from './routes/properties.routes.js';
import valuationsRoutes from './routes/valuations.routes.js';
import configurationRoutes from './routes/configuration.routes.js';
import adminRoutes from './routes/admin.routes.js';
import propertyRoutes from './routes/property.routes.js';
import researchRoutes from './routes/research.routes.js';

const routes = [
  ...mandatesRoutes,
  ...propertiesRoutes,
  ...valuationsRoutes,
  ...configurationRoutes,
  ...adminRoutes,
  ...propertyRoutes,
  ...researchRoutes,
  { path: '/landing', name: 'landing', component: () => import(/* webpackChunkName: "landing" */ '@/pages/landing.vue') },
  { path: '/about', name: 'about', component: () => import(/* webpackChunkName: "about" */ '@/pages/about.vue'), meta: { auth: true } },
  { path: '/pricingTool', name: 'pricingTool', component: () => import(/* webpackChunkName: "pricingTool" */ '@/pages/pricingTool/pricingTool.vue'), meta: { auth: true } },

  { path: '/newMandate/:rowMandateId?', name: 'newMandate', component: () => import(/* webpackChunkName: "newMandate" */ '@/pages/mandate/pixCreateMandate.vue'), props: true },

  /** Personas Management */
  { path: '/personasList', name: 'personasList', component: () => import(/* webpackChunkName: "pixPersonasList" */ '@/pages/persons/pixPersonasList.vue'), meta: { auth: true } },
  {
    path: '/personasDetails/:rowUserId',
    name: 'personasDetails',
    component: () => import(/* webpackChunkName: "pixPersonasDetail" */ '@/pages/persons/pixPersonasDetails/pixPersonasDetail.vue'),
    props: true,
    meta: {
      auth: true,
    },
    beforeEnter: pixPersonasDetailGuard,
  },

  /* FallBack por defecto */
  { path: '*', name: 'defaultRedirect', redirect: '/landing' },

  /* Error page no auth */
  { path: '/errAuth', name: 'errAuth', component: () => import(/* webpackChunkName: "errAuth" */ '@/pages/errAuth.vue') },
];

export default routes;
